import { LockStatus } from "@variocube/app-api";
import { Badge } from "./badge.js";
import * as React from "react";
import { toT } from "./utils.js";
export function LockStatusBadge({ lockStatus, strings }) {
    const t = toT(strings);
    const label = t(`LockStatus:${lockStatus}`) || lockStatus;
    return (React.createElement(Badge, { warning: lockStatus == LockStatus.Open, error: lockStatus == LockStatus.Blocked || lockStatus == LockStatus.Breakin }, label));
}
//# sourceMappingURL=LockStatusBadge.js.map